import React from 'react';
import {Container, Row, Col } from 'react-bootstrap';
import Heading from '../../components/heading/heading';
import './joinContent.scss';

import JoinFormSubmitSuccess from './joinFormSubmitSuccess';
import JoinForm from './joinForm';
import posttelemetry from '../../common/telemetry';
import {postinvitationrequest} from '../../components/net/api';

class JoinContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {showSuccess: false};
    this.handleSubmit = this.handleSubmit.bind(this);

  }

  handleSubmit(data) {
    //TODO call API to store the invite request

    //TODO figure out if we want to do that.
    //if so, we need to record when we come from a specific landing page.
    //otherwise the info makes no sense.
    posttelemetry('join_queue', data, 'joinform');

    postinvitationrequest(data.email, data.motivation).then(res => {
      this.setState({showSuccess: true, serverError: false});
    })
    .catch(error => {
    this.setState({showSuccess: false, serverError: true});
    //TODO display error.
        })




  }

  render() {
    return (
      <Container className="signup-form w-75">

        <Row style={{minHeight:'40rem'}}>
          <Col md={7} className="pr-md-5">
          <Heading as="h3" type="display">Join us!</Heading>
          {this.state.showSuccess ? 
          <JoinFormSubmitSuccess />
            :            
          <JoinForm onSubmit={this.handleSubmit} serverError={this.state.serverError}/>
          }

          </Col>
          <Col className="d-none d-md-inline signup-image" md={5}>
          
          
            </Col>
        </Row>

      </Container>
    )
  }
}

export default JoinContent;